import React, { useEffect, useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import api from '../utils/axiosConfig';
import './ApplicantForm.css';


const ApplicantForm = () => {
  const { programId, programName, admissionSemesterUID, semester } = useParams();



  const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
  const [selectedGender, setSelectedGender] = useState([]);
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState([]);
  const [religion, setReligion] = useState([]);
  const [nationality, setNationality] = useState(null);

  const [errors, setErrors] = useState({ 
    applicant_mobile_no: '',
    spouse_mobile_no: '', 
    father_mobile_no: '', 
    mother_mobile_no: '', 
    local_guardian_mobile_no: '',
    ssc_passing_year: '',
    hsc_passing_year: '',
    sibling_student_id_num: '',
  });


  const [formData, setFormData] = useState({
    applicant_name: '',
    applicant_photo_file: '',
    program_id: programId,
    adm_sem_uid: admissionSemesterUID,
    admission_semester: semester,
    
    //Personal Info
    applicant_mobile_no: '',
    applicant_email: '',
    dob: '',
    blood_group_id: '',
    gender_id: '',
    marital_status_id: '',
    nid_birth_certificate: '',
    religion_id: '',
    country_id: '',
  
    // Spouse Info
    spouse_name: '',
    spouse_mobile_no: '',
  
    // Parents Info
    father_name: '',
    mother_name: '',
    father_mobile_no: '',
    mother_mobile_no: '',
    father_occupation: '',
    mother_occupation: '',
    family_income_annual: '',
  
    // Present Address
    present_district: '',
    present_upazila: '',
    present_police_station: '',
    present_post_office: '',
    present_village: '',
  
    // Permanent Address
    permanent_district: '',
    permanent_upazila: '',
    permanent_police_station: '',
    permanent_post_office: '',
    permanent_village: '',
  
    // Local Guardian Info
    local_guardian_name: '',
    local_guardian_address: '',
    local_guardian_mobile_no: '',
    local_guardian_relation: '',
  
    // SSC Info
    ssc_passing_year: '',
    ssc_board: '',
    ssc_group_name: '',
    ssc_roll_no: '',
    ssc_reg_no: '',
    ssc_session: '',
    ssc_gpa: '',
    ssc_was_gpa: '',
    ssc_institution_name: '',
  
    // HSC Info
    hsc_passing_year: '',
    hsc_board: '',
    hsc_group_name: '',
    hsc_roll_no: '',
    hsc_reg_no: '',
    hsc_session: '',
    hsc_gpa: '',
    hsc_was_gpa: '',
    hsc_institution_name: '',
  
    // Additional Info
    freedom_fighter: '',
    sibling_student_id_num: '',
    sibling_name: '',
  });
  

  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    let updatedValue = value;
  
    if (name !== "applicant_email") {
      updatedValue = capitalizeFirstLetter(value);
    } else {
      updatedValue = value.toLowerCase(); // force lowercase for email
    }
  
    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };
  

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.files[0], // this keeps it as a File
    }));
  };
  
  const loadBloodGroups = async (inputValue) => {
    try {
      const response = await api.get('fetch-blood-groups', {
        params: { search: inputValue },
      });

      return response.data.map((item) => ({
        value: item.id,
        label: item.text,
      }));
    } catch (error) {
      console.error('Failed to load blood groups:', error);
      return [];
    }
  };

  const handleBloodGroupChange = (selectedOption) => {
    setSelectedBloodGroup(selectedOption);
    setFormData((prev) => ({
      ...prev,
      blood_group_id: selectedOption?.value || '',
    }));
  };

 
  const loadNationality = async (inputValue) => {
    try {
      const response = await api.get('fetch-nationality', {
        params: { search: inputValue },
      });

      return response.data.map((item) => ({
        value: item.id,
        label: item.text,
      }));
    } catch (error) {
      console.error('Failed to load Nationality:', error);
      return [];
    }
  };

  const handleNationalityChange = (selectedOption) => {
    setNationality(selectedOption);
    setFormData((prev) => ({
      ...prev,
      country_id: selectedOption?.value || '',
    }));
  };


  const handleSameAsPresent = (e) => {
    const isChecked = e.target.checked;
  
    if (isChecked) {
      setFormData((prevData) => ({
        ...prevData,
        permanent_district: prevData.present_district,
        permanent_upazila: prevData.present_upazila,
        permanent_police_station:prevData.present_police_station,
        permanent_post_office: prevData.present_post_office,
        permanent_village: prevData.present_village,
      }));
    } else {
      // Optional: clear permanent fields when unchecked
      setFormData((prevData) => ({
        ...prevData,
        permanent_district: '',
        permanent_upazila: '',
        permanent_police_station: '',
        permanent_post_office: '',
        permanent_village: '',
      }));
    }
  };


   // State to track checkbox
   const [hasSiblings, setHasSiblings] = useState(false);

   // Handle checkbox change
   const handleSiblingCheckboxChange = (e) => {
     setHasSiblings(e.target.checked);
   };
  


   useEffect(() => {
      api.get(`fetch-genders`).then((res) => {
        setSelectedGender(res.data);
      });

      api.get(`fetch-marital-status`).then((res) => {
        setSelectedMaritalStatus(res.data);
      });

      api.get(`fetch-religions`).then((res) => {
        setReligion(res.data);
      });
  }, []);


  //Validation 

  const ValidateAlphabetDotOnly = (event) => {
    const keyCode = event.keyCode || event.which;
  
    // A-Z, a-z, dot (.), space ( ), and hyphen (-) allowed
    if (
      (keyCode >= 65 && keyCode <= 90) ||  // A-Z
      (keyCode >= 97 && keyCode <= 122) || // a-z
      keyCode === 46 ||                    // Dot (.)
      keyCode === 32 ||                    // Space
      keyCode === 45                       // Hyphen (-)
    ) {
      return true;  // Allow these keys
    } else {
      event.preventDefault();  // Block other keys
    }
  };
  

  const capitalizeFirstLetter = (input) => {
    if (typeof input !== "string") {
      return input; // If it's not a string, just return the input
    }
  
    return input
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };



  const validateDigit = (event) => {
    const keyCode = event.keyCode || event.which;

    // Allow backspace, delete, arrow keys, and tab
    if (
      keyCode === 8 ||  // Backspace
      keyCode === 46 || // Delete
      keyCode === 9  || // Tab
      (keyCode >= 37 && keyCode <= 40) // Arrow keys
    ) {
      return; // Allow these keys
    }
  
    // Allow only numeric input (0-9)
    if ((keyCode < 48 || keyCode > 57) && (keyCode < 96 || keyCode > 105)) {
      event.preventDefault();
    }
  };
  
  // Function to validate on form submission
  const validateInputLength = (event, minLength, maxLength) => {
    const input = event.target;
    const value = input.value.trim();
  
    if (value.length < minLength || value.length > maxLength) {
      if(minLength === maxLength){
        setErrors((prev) => ({
          ...prev,
            [input.name]: `Input must be exactlly ${maxLength} digits.`,
        }));
      }else{
        setErrors((prev) => ({
          ...prev,
          [input.name]: `Input must be between ${minLength} and ${maxLength} digits.`,
        }));
      }
  
      event.preventDefault();
      input.focus();
    } else {
      setErrors((prev) => ({
        ...prev,
        [input.name]: '',
      }));
    }
  };
  

  const validateGPAInput = (event) => {
    const input = event.target;
    const value = input.value;
    const regex = /^[0-9](\.[0-9]{0,2})?$/;
    if (!regex.test(value)) {
      // If not, remove the last character
      input.value = value.slice(0, -1);
    }
  };
  
  
const [isSubmitting, setIsSubmitting] = useState(false);
const handleSubmit = async (e) => {
      e.preventDefault();

      // Set isSubmitting to true to disable the submit button
      setIsSubmitting(true);

      if (!nationality) {
        Swal.fire({
          title: 'Error!',
          text: 'Nationality Field is required.',
          icon: 'error',
          confirmButtonText: 'Cool'
        });
        setIsSubmitting(false); // Reset submission status on error
        return;
      }

      // Create FormData and append all fields
      const formPayload = new FormData();
      for (let key in formData) {
        formPayload.append(key, formData[key]);
      }

      try {
        const res = await api.post('store-online-applicant-data', formPayload, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        const { title, message, icon } = res.data;


        Swal.fire({
          title: title,
          text: message,
          icon: icon,
        }).then(() => {
          if(title === 'Success') {
              window.location.reload();
          }
        });

      } catch (err) {
        Swal.fire({
          title: 'Error!',
          text: err.response?.data?.message || "Something went wrong.",
          icon: 'error',
        });
      }finally {
        // Reset isSubmitting to false after the process is complete
        setIsSubmitting(false);
      }
};


  return (
    <Container className="bg-ash border rounded-3 border-2 border-white">
      <div className="mb-1 text-center">
        <h5>Application Form</h5>
        <hr />
      </div>

      <div className="mb-1">
        <form onSubmit={handleSubmit} encType="multipart/form-data">

          {/* Applicant Information */}
          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Applicant's Information</legend>
                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="applicant_name" className="col-sm-4 col-form-label">
                        Name <b>(English)</b>: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="applicant_name" name="applicant_name" value={formData.applicant_name}  onChange={(e) => {handleChange(e);  capitalizeFirstLetter(e);}} onKeyPress={ValidateAlphabetDotOnly} required/>
                        <b className='text-danger'>[Name as per your academic certificate]</b>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="applicant_photo_file" className="col-sm-4 col-form-label">
                        Photo <b>(Passport Size):</b> <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                      <input type="file" className="form-control form-control-sm" id="applicant_photo_file" name="applicant_photo_file" onChange={handleFileChange} required accept=".jpg"
                      />
                        <b className='text-danger'>[JPG max 50KB (Resolution: 300&times;366 px)]</b>
                      </div>
                    </div>
                  </Col>

                </Row>
                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="program_id" className="col-sm-4 col-form-label">
                        Your Program:
                      </label>
                      <div className="col-sm-8">
                        <select className="form-control form-control-sm" id="program_id" name="program_id" value={formData.program_id} onChange={handleChange} readOnly>
                          <option value={programId}>{programName}</option>
                        </select>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="admission_semester" className="col-sm-4 col-form-label">
                        Admission Semester:
                      </label>
                      <div className="col-sm-8">
                        <select className="form-control form-control-sm"id="admission_semester"name="admission_semester" value={formData.admission_semester} onChange={handleChange} readOnly>
                          <option value={semester}>{semester}</option>
                        </select>
                        {/* <input type="text" value={admissionSemesterUID} /> */}
                      </div>
                    </div>
                  </Col>
                </Row>
          </fieldset>

            {/* Personal Information */}
          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Personal Information</legend>
            <Row className="mb-1">
              <Col md={6}>
                <div className="row">
                  <label htmlFor="applicant_mobile_no" className="col-sm-4 col-form-label">
                    Applicant's Mobile: <b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <input type="text" className="form-control form-control-sm" id="applicant_mobile_no" name="applicant_mobile_no" value={formData.applicant_mobile_no} onChange={handleChange}   onKeyDown={(event) => validateDigit(event)} onBlur={(event) => validateInputLength(event, 11, 11)} required/>
                    <b className="text-danger">{errors.applicant_mobile_no}</b>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div className="row">
                  <label htmlFor="applicant_email" className="col-sm-4 col-form-label" title='NID / Birth Certificate No'>
                     E-mail:
                  </label>
                  <div className="col-sm-8">
                    <input type="email" className="form-control form-control-sm" id="applicant_email" name="applicant_email" value={formData.applicant_email} onChange={handleChange} />
                  </div>
                </div>
              </Col>

            </Row>

            <Row className="mb-1">
              
            <Col md={6}>
                <div className="row">
                  <label htmlFor="dob" className="col-sm-4 col-form-label">
                    Date of Birth <b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <input type="date" className="form-control form-control-sm" id="dob"  name="dob" value={formData.dob} onChange={handleChange} required/>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="row">
                  <label htmlFor="gender_id" className="col-sm-4 col-form-label">
                    Gender: <b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <select className="form-control form-control-sm" id="gender_id" name="gender_id" value={formData.gender_id} onChange={handleChange} required>
                      <option value="">Select Your Gender</option> 
                      {
                        selectedGender.map((item) => {
                          return <option value={item.id} key={item.id}>{item.text}</option>;
                        })
                      }
                    </select>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-1">

              <Col md={6}>
                <div className="row">
                  <label htmlFor="blood_group_id" className="col-sm-4 col-form-label">
                    Blood Group:
                  </label>
                  <div className="col-sm-8">
                    <AsyncSelect cacheOptions loadOptions={loadBloodGroups} defaultOptions value={selectedBloodGroup} onChange={handleBloodGroupChange} placeholder="Select/Search Blood Group"
                    />
                  </div>
                </div>
              </Col>



              <Col md={6}>
                <div className="row">
                  <label htmlFor="nid_birth_certificate" className="col-sm-4 col-form-label" title='NID / Birth Certificate No'>
                     NID/Birth Cert. No:<b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <input type="text" className="form-control form-control-sm" id="nid_birth_certificate" name="nid_birth_certificate" value={formData.nid_birth_certificate} onChange={handleChange} min={0}  placeholder='Please, type your NID / Birth Certificate No' required />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-1">

            <Col md={6}>
                <div className="row">
                  <label htmlFor="marital_status_id" className="col-sm-4 col-form-label">
                    Marital Status: <b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <select className="form-control form-control-sm" id="marital_status_id" name="marital_status_id" value={formData.marital_status_id} onChange={handleChange} required>
                      <option value="">Select Your Marital Status</option>
                      {
                        selectedMaritalStatus.map((item)=>{
                          return <option value={item.id} key={item.id}>{item.text}</option>;
                        })
                      }
                    </select>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div className="row">
                  <label htmlFor="religion_id" className="col-sm-4 col-form-label">
                    Religion: <b className="text-danger">*</b>
                  </label>
                  <div className="col-sm-8">
                    <select
                      className="form-control form-control-sm" id="religion_id" name="religion_id" value={formData.religion_id} onChange={handleChange} required >
                      <option value="">Select Your Religion</option>
                      {
                        religion.map((item)=>{
                          return <option value={item.id} key={item.id}>{item.text}</option>;
                        })
                      }
                    </select>
                  </div>
                </div>
              </Col>
              


            </Row>

            {formData.marital_status_id === '2' && (
              <Row className="mb-1">
                <Col md={6}>
                  <div className="row">
                    <label htmlFor="spouse_name" className="col-sm-4 col-form-label">
                      Spouse Name: <b className="text-danger">*</b>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control form-control-sm" id="spouse_name" name="spouse_name" value={formData.spouse_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly}
                        required
                      />
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="row">
                    <label htmlFor="spouse_mobile_no" className="col-sm-4 col-form-label">
                      Spouse's Mobile No: <b className="text-danger">*</b>
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className="form-control form-control-sm" id="spouse_mobile_no" name="spouse_mobile_no" value={formData.spouse_mobile_no} onChange={handleChange} onKeyDown={validateDigit} onBlur={(event) => validateInputLength(event, 11, 11)} required />
                       <b className="text-danger">{errors.spouse_mobile_no}</b>
                    </div>
                  </div>
                </Col>
              </Row>
            )
            }

            <Row className="mb-1">


              <Col md={6}>
                <div className="row">
                  <label htmlFor="country_id" className="col-sm-4 col-form-label">
                    Nationality: <b className="text-danger">*</b>
                  </label>
                    <div className="col-sm-8">
                        <AsyncSelect cacheOptions loadOptions={loadNationality} defaultOptions value={nationality} onChange={handleNationalityChange} placeholder="Select/Search Nationality" />               
                    </div>
                </div>
              </Col>
            </Row>
          </fieldset>

            {/* Parents Information */}
          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Parents Information</legend>
                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="father_name" className="col-sm-4 col-form-label">
                       Father Name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="father_name" name="father_name" value={formData.father_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="mother_name" className="col-sm-4 col-form-label">
                       Mother Name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="mother_name" name="mother_name" value={formData.mother_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="father_mobile_no" className="col-sm-4 col-form-label">
                       Father's Mobile No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="father_mobile_no" name="father_mobile_no" value={formData.father_mobile_no} onChange={handleChange} onKeyDown={validateDigit} onBlur={(event) => validateInputLength(event, 11, 11)} required/>
                        <b className="text-danger">{errors.father_mobile_no}</b>
                      </div>
                    </div>
                  </Col>

                  
                  <Col md={6}>
                      <div className="row">
                        <label htmlFor="mother_mobile_no" className="col-sm-4 col-form-label">
                        Mother's Mobile No:
                        </label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control form-control-sm" id="mother_mobile_no" name="mother_mobile_no" value={formData.mother_mobile_no} onChange={handleChange} onKeyDown={validateDigit}  />
                        </div>
                      </div>
                    </Col>
                </Row>

                <Row className="mb-1">
                     <Col md={6}>
                        <div className="row">
                          <label htmlFor="father_occupation" className="col-sm-4 col-form-label">
                          Father Occupation: 
                          </label>
                          <div className="col-sm-8">
                            <input type="text" className="form-control form-control-sm" id="father_occupation" name="father_occupation" value={formData.father_occupation} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly}/>
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="row">
                          <label htmlFor="mother_occupation" className="col-sm-4 col-form-label">
                          Mother Occupation: 
                          </label>
                          <div className="col-sm-8">
                            <input type="text" className="form-control form-control-sm" id="mother_occupation" name="mother_occupation" value={formData.mother_occupation} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly}/>
                          </div>
                        </div>
                      </Col>
                </Row>

                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="family_income_annual" className="col-sm-4 col-form-label">
                        Family Income<b className="text-danger">*</b><b>[Annual]</b>:
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="family_income_annual" name="family_income_annual" value={formData.family_income_annual} onChange={handleChange}  required
                            />
                      </div>
                    </div>
                  </Col>
                
                </Row>
          </fieldset>

          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Address</legend>
                <Row className="mb-1">
                  <Col md={6}>
                     <h6>Present Address</h6>
                     <hr />
                    <div className="row">
                      <label htmlFor="present_district" className="col-sm-4 col-form-label">
                        District: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                           <input type="text" className="form-control form-control-sm" id="present_district" name="present_district" value={formData.present_district} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="present_upazila" className="col-sm-4 col-form-label">
                        Upazila: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="present_upazila" name="present_upazila" value={formData.present_upazila} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="present_police_station" className="col-sm-4 col-form-label">
                        Police Station: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="present_police_station" name="present_police_station" value={formData.present_police_station} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="present_post_office" className="col-sm-4 col-form-label">
                        Post Office: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="present_post_office" name="present_post_office" value={formData.present_post_office} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="present_village" className="col-sm-4 col-form-label">
                        Village / Ward No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="present_village" name="present_village" value={formData.present_village} onChange={handleChange} required />
                      </div>
                    </div>

                  </Col>

                  <Col md={6}>
                     <h6>permanent Address <small className='fw-bold'>[Same as present address]</small> <input type="checkbox" name="same_as_present" id="same_as_present"  onChange={(e) => handleSameAsPresent(e)} /> </h6>
                     <hr />
                    <div className="row">
                      <label htmlFor="permanent_district" className="col-sm-4 col-form-label">
                        District: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                           <input type="text" className="form-control form-control-sm" id="permanent_district" name="permanent_district" value={formData.permanent_district} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="permanent_upazila" className="col-sm-4 col-form-label">
                        Upazila: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="permanent_upazila" name="permanent_upazila" value={formData.permanent_upazila} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="permanent_police_station" className="col-sm-4 col-form-label">
                        Police Station: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="permanent_police_station" name="permanent_police_station" value={formData.permanent_police_station} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="permanent_post_office" className="col-sm-4 col-form-label">
                        Post Office: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="permanent_post_office" name="permanent_post_office" value={formData.permanent_post_office} onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="permanent_village" className="col-sm-4 col-form-label">
                        Village: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="permanent_village" name="permanent_village" value={formData.permanent_village} onChange={handleChange} required />
                      </div>
                    </div>

                  </Col>
                </Row>
          </fieldset>

          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Details of Reference/Local Guardian(Should not be parents)</legend>
                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="local_guardian_name" className="col-sm-4 col-form-label">
                        Name <b>(English)</b>: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="local_guardian_name" name="local_guardian_name" value={formData.local_guardian_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required/>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="local_guardian_address" className="col-sm-4 col-form-label">
                        Address: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                      <input type="text" className="form-control form-control-sm" id="local_guardian_address" name="local_guardian_address" value={formData.local_guardian_address} onChange={handleChange} required/>
                      </div>
                    </div>
                  </Col>

                </Row>
                <Row className="mb-1">
                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="local_guardian_mobile_no" className="col-sm-4 col-form-label">
                        Mobile No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="local_guardian_mobile_no" name="local_guardian_mobile_no" value={formData.local_guardian_mobile_no}  onChange={handleChange} onKeyDown={validateDigit} onBlur={(event) => validateInputLength(event, 11, 11)} required/>
                        <b className="text-danger">{errors.local_guardian_mobile_no}</b>
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="row">
                      <label htmlFor="local_guardian_relation" className="col-sm-4 col-form-label">
                        Relation: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                      <input type="text" className="form-control form-control-sm" id="local_guardian_relation" name="local_guardian_relation" value={formData.local_guardian_relation} onChange={handleChange}
                         onKeyPress={ValidateAlphabetDotOnly} required/>
                      </div>
                    </div>
                  </Col>
                </Row>
          </fieldset>

          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Educational Qualification</legend>
                <Row className="mb-1">
                  <Col md={6}>
                     <h6>S.S.C or Equivalent</h6>
                     <hr />
                     <div className="row">
                      <label htmlFor="ssc_passing_year" className="col-sm-4 col-form-label">
                       Passing Year: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="ssc_passing_year" name="ssc_passing_year" value={formData.ssc_passing_year} onChange={handleChange}  placeholder='Please enter a 4-digit year (e.g., 2026)' onBlur={(event) => validateInputLength(event, 4, 4)}  required />
                         <b className="text-danger">{errors.ssc_passing_year}</b>
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_board" className="col-sm-4 col-form-label">
                       Board: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="ssc_board" name="ssc_board" value={formData.ssc_board} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="row">
                      <label htmlFor="ssc_group_name" className="col-sm-4 col-form-label">
                        Group Name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="ssc_group_name" name="ssc_group_name" value={formData.ssc_group_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_roll_no" className="col-sm-4 col-form-label">
                        Roll No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="ssc_roll_no" name="ssc_roll_no" value={formData.ssc_roll_no} onChange={handleChange}  required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_reg_no" className="col-sm-4 col-form-label">
                        Registration No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="ssc_reg_no" name="ssc_reg_no" value={formData.ssc_reg_no} onChange={handleChange}  required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_session" className="col-sm-4 col-form-label">
                        Session: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="ssc_session" name="ssc_session" value={formData.ssc_session} onChange={handleChange} placeholder='Please enter sesion (e.g., 2015-16)' required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_gpa" className="col-sm-4 col-form-label">
                        GPA: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8 d-flex align-items-center gap-2">
                        <input type="text" className="form-control form-control-sm w-25" id="ssc_gpa" name="ssc_gpa" value={formData.ssc_gpa} onChange={handleChange} required onInput={validateGPAInput}/>
                        <label htmlFor="ssc_was_gpa">GPA:</label><small className='m-0 fw-bold' style={{fontSize:'10px'}}>[Without Additional Subject]</small>
                        <input type="text" className="form-control form-control-sm w-25 m-0" id="ssc_was_gpa" name="ssc_was_gpa" value={formData.ssc_was_gpa} onChange={handleChange} onInput={validateGPAInput} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="ssc_institution_name" className="col-sm-4 col-form-label">
                        Institution name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="ssc_institution_name" name="ssc_institution_name" value={formData.ssc_institution_name} onChange={handleChange} required />
                      </div>
                    </div>

                  </Col>

                  <Col md={6}>
                     <h6>H.S.C or Equivalent</h6>
                     <hr />
                     <div className="row">
                      <label htmlFor="hsc_passing_year" className="col-sm-4 col-form-label">
                       Passing Year: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="hsc_passing_year" name="hsc_passing_year" value={formData.hsc_passing_year} onChange={handleChange} onBlur={(event) => validateInputLength(event, 4, 4)} required />
                         <b className="text-danger">{errors.hsc_passing_year}</b>
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_board" className="col-sm-4 col-form-label">
                       Board: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="hsc_board" name="hsc_board" value={formData.hsc_board} onChange={handleChange} required />
                      </div>
                    </div>
                    <div className="row">
                      <label htmlFor="hsc_group_name" className="col-sm-4 col-form-label">
                        Group Name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="hsc_group_name" name="hsc_group_name" value={formData.hsc_group_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_roll_no" className="col-sm-4 col-form-label">
                        Roll No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="hsc_roll_no" name="hsc_roll_no" value={formData.hsc_roll_no}  onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_reg_no" className="col-sm-4 col-form-label">
                        Registration No: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                         <input type="text" className="form-control form-control-sm" id="hsc_reg_no" name="hsc_reg_no" value={formData.hsc_reg_no}  onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_session" className="col-sm-4 col-form-label">
                        Session: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="hsc_session" name="hsc_session" value={formData.hsc_session} onChange={handleChange} placeholder='Please enter sesion (e.g., 2017-18)' required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_gpa" className="col-sm-4 col-form-label">
                        GPA: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8 d-flex align-items-center gap-2">
                        <input type="text" step="0.01" className="form-control form-control-sm w-25" id="hsc_gpa" name="hsc_gpa" value={formData.hsc_gpa} onChange={handleChange} onInput={validateGPAInput} required />
                        <label htmlFor="hsc_was_gpa">GPA:</label><small className='m-0 fw-bold' style={{fontSize:'10px'}}>[Without Additional Subject]</small>
                        <input type="text" step="0.01" className="form-control form-control-sm w-25 m-0" id="hsc_was_gpa" name="hsc_was_gpa" value={formData.hsc_was_gpa} onChange={handleChange} onInput={validateGPAInput} required />
                      </div>
                    </div>

                    <div className="row">
                      <label htmlFor="hsc_institution_name" className="col-sm-4 col-form-label">
                        Institution name: <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control form-control-sm" id="hsc_institution_name" name="hsc_institution_name" value={formData.hsc_institution_name} onChange={handleChange}  required />
                      </div>
                    </div>

                  </Col>

                </Row>
          
          </fieldset>

          <fieldset className="border border-success rounded-3 p-3 my-4">
            <legend className="float-none w-auto px-3 fw-bold">Freedom Fighter & Siblings</legend>
                <Row className="mb-1">
                  <Col md={12}>
                    <div className="row">
                      <label htmlFor="freedom_fighter" className="col-sm-4 col-form-label">
                        Were your parents Freedom Fighter? <b className="text-danger">*</b>
                      </label>
                      <div className="col-sm-8 d-flex align-items-center gap-3">
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="freedom_fighter" id="freedom_fighter_yes" value="1" checked={formData.freedom_fighter === "1"} onChange={handleChange} required/>
                          <label className="form-check-label" htmlFor="freedom_fighter_yes">
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input className="form-check-input" type="radio" name="freedom_fighter" id="freedom_fighter_no" value="0" checked={formData.freedom_fighter === "0"} onChange={handleChange} />
                          <label className="form-check-label" htmlFor="freedom_fighter_no">
                            No
                          </label>
                        </div>
                      </div>
                    </div>

                  </Col>
                </Row>

                <Row className="my-3">
                  <Col md={12}>
                    <label className="d-inline">Do you have any siblings currently enrolled at KYAU? <b className="text-danger">*</b></label>
                    <input type="checkbox" name="sibling_check" id="sibling_check" className="mx-2 d-inline" onChange={handleSiblingCheckboxChange} />
                  </Col>
                </Row>

                  {/* Sibling Section */}
                  {hasSiblings && (
                    <Row className="mt-4">
                      <Col md={6}>
                        <div className="row">
                          <label htmlFor="sibling_student_id_num" className="col-sm-4 col-form-label">
                            Student ID: <b className="text-danger">*</b>
                          </label>
                          <div className="col-sm-8">
                            <input type="text" className="form-control form-control-sm" id="sibling_student_id_num" name="sibling_student_id_num"  value={formData.sibling_student_id_num} onChange={handleChange} placeholder="Please type your sibling's full Student ID" onBlur={(event) => validateInputLength(event, 14, 16)} required/>
                            <b className="text-danger">{errors.sibling_student_id_num}</b>
                          </div>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="row">
                          <label htmlFor="sibling_name" className="col-sm-4 col-form-label">
                            Name <b>(English)</b>: <b className="text-danger">*</b>
                          </label>
                          <div className="col-sm-8">
                            <input type="text" className="form-control form-control-sm" id="sibling_name" name="sibling_name" value={formData.sibling_name} onChange={handleChange} onKeyPress={ValidateAlphabetDotOnly} required
                            />
                          </div>
                        </div>
                      </Col>

                    </Row>
                  )}
  
    
          </fieldset>

            <div className="row my-5">
                <div className="col">
                    <h6 className='fw-bold text-danger'>Instruction</h6>
                    <ul className=''>
                       <li className="f-italic">Before filling out the application form, please read the input data carefully.</li>
                       <li className="f-italic">By submitting your application to KYAU, you agree to adhere to the university's policies. Admission is based on merit, academic qualifications, and other criteria. Providing false information may lead to disqualification.</li>
                    </ul>
                </div>
            </div>

            <div className="my-5 d-flex justify-content-center">
            <button type="submit" className="btn btn-success rounded-pill btn-sm w-25" disabled={isSubmitting}>
              Submit
            </button>
          </div>


        </form>
      </div>
    </Container>
  );
};

export default ApplicantForm;
